var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-relative tendermint-tx-wrapper"},[(_vm.currentProject)?_c(_vm.$route.query.type,{tag:"component",on:{"close":function($event){return _vm.$emit('close')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }